import React, { useState } from 'react';
import Button from '../../../components/ui/Button';
import Select from '../../../components/ui/Select';

const BulkActionsBar = ({ selectedCount, onBulkApprove, onBulkReject, onBulkExport, onBulkAssign }) => {
  const [assignTo, setAssignTo] = React.useState('');

  if (selectedCount === 0) return null;

  return (
    <div className="bg-primary/10 border border-primary/20 rounded-lg p-4 mb-6">
      <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
        <div className="flex items-center gap-2">
          <span className="text-sm font-medium text-foreground">
            {selectedCount} {selectedCount === 1 ? 'submission' : 'submissions'} selected
          </span>
        </div>
        
        <div className="flex flex-wrap items-center gap-2">
          <Button
            variant="default"
            size="sm"
            iconName="Check"
            iconPosition="left"
            onClick={onBulkApprove}
          >
            Approve
          </Button>
          
          <Button
            variant="destructive"
            size="sm"
            iconName="X"
            iconPosition="left"
            onClick={onBulkReject}
          >
            Reject
          </Button>
          
          <Button
            variant="outline"
            size="sm"
            iconName="Download"
            iconPosition="left"
            onClick={onBulkExport}
          >
            Export
          </Button>

          <div className="flex items-center gap-2">
            <Select
              placeholder="Assign to..."
              options={[
                { value: 'hr-manager', label: 'HR Manager' },
                { value: 'dept-head', label: 'Department Head' },
                { value: 'ceo', label: 'CEO' }
              ]}
              value={assignTo}
              onChange={setAssignTo}
              className="w-40"
            />
            <Button
              variant="secondary"
              size="sm"
              iconName="UserPlus"
              onClick={() => onBulkAssign(assignTo)}
              disabled={!assignTo}
            >
              Assign
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BulkActionsBar;